module.exports = __webpack_public_path__ + "img/1.117b252f.png";